module.exports = __webpack_public_path__ + "img/xxx.82ff0e39.jpg";